/**
 * classNames — tiny conditional className joiner. Pure, no deps.
 * Usage: cx(styles.row, isActive && styles.active, className)
 */
export function cx(...parts) {
  return parts.filter(Boolean).join(' ');
}
